import { BlProfile, Dictionary, Session } from '../types/working-model';
import { PostHv } from './helpers';

export enum EValidateRegistrationResponseType {
	valid = "valid",
	invalid = "invalid"
}

export interface IValidateRegistrationResponse {
	bundle?: { sessions: Session[] };
	response: EValidateRegistrationResponseType;
	playbackUrls: Dictionary;
	validSessions: string[];
	paidSessions: string[];
	paymentRequired: boolean;
}

export function ValidateRegistration(eventUuid: string, registration_id: string, bl_token?: string): Promise<IValidateRegistrationResponse> {
	return PostHv(`/e3-validate-registration/${eventUuid}`, { registration_id }, bl_token);
}

interface Dict {
	[key: string]: any;
}

export interface IRegistrationResponse {
	registration: string;
	mustVerify: boolean;
	token: string;
	validSessions?: string[];
	secureEvent: { sessions: Session[] };
}

export interface IRegistrationRequest {
	fields: Dict;
	lang: string;
	source: string;
	timezone: string;
	isFinalStep: boolean;
	userCode?: string;
}

export function Register(request: IRegistrationRequest, uuid: string, bl_token?: string): Promise<IRegistrationResponse> {
	return PostHv(`/e3-create-registration/${uuid}`, { ...request }, bl_token);
}

export interface IProfileComplete {
	fields: Dict;
	lang: string;
	channel: number;
	avatar: string | null;
	isFinalStep: boolean;
	mustVerify?: boolean;
	registrationId: string;
	eventUuid?: string;
	emailAddress?: string;
	source?: string;
	timezone?: string;
}

export interface IStripeOptions {
	channel_id: number,
	event_uuid: string,
	profile: BlProfile | null,
	registration_uuid: string | null,
}

export interface IStripeData {
	[key: string]: string | boolean;
}

export function CompleteProfile(request: IProfileComplete, bl_token?: string): Promise<{ token: string }> {
	return PostHv(`/e3-complete-profile`, { ...request }, bl_token);
}

export function CreateStripeIntent(options: IStripeOptions, data: IStripeData): Promise<{ clientSecret: string }> {
	return PostHv('/e3-create-intent', { options, data });
}

export function VerifyProfile(token: string, code: string): Promise<{ newToken?: string, userCode?: string, message?: string, error?: string }> {
	return PostHv(`/e3-verify-profile`, { verificationCode: code }, token);
}

export interface IReRegistrationRequest {
	lang: string;
	timezone: string;
	eventUuid: string;
	email: string;
}

export function ReRegister({ lang, timezone, eventUuid, email }: IReRegistrationRequest): Promise<any> {
	return PostHv(`/e3-reregister/${eventUuid}`, { emailAddress: email, lang, timezone, source: window.location.href.replace('/registration', '').replace('?', '') });
}

interface IReRegisterResponse {
	secureEvent: { sessions: Session[] };
	token: string;
	registration: string;
	playbackUrls: Dictionary;
	userCode: string;
	validSessions: string[];
	registrationId: string;
	paymentRequired: boolean;
}

export function ReRegisterCheck(eventUuid: string, code: string): Promise<IReRegisterResponse> {
	return PostHv(`/e3-reregister-check/${eventUuid}`, { code });
}